/*********************************************************************************
 1. Dependencies
 *********************************************************************************/

import styled                                     from 'styled-components';
import { Colours, Spacing, Borders }              from '../../../styles/variables';
import { Media }                                  from '../../../styles/utilities';
import { transparentize }                         from "polished/lib/index";


/*********************************************************************************
 2. Component
 *********************************************************************************/

export const StyledContent = styled.div`
  margin: ${Spacing.Small};
  padding: ${Spacing.Small};
  color: ${Colours.Tundora};
  background: ${Colours.White};
  border-top: 1px solid ${Colours.Gallery};
  border-radius: ${Borders.Radius};
  box-shadow: 0 1px 1px 0 ${transparentize(0.7, Colours.Tundora)};
  position: relative;
  ${Media.Tablet`
    margin: ${Spacing.Massive};
    flex-basis: 960px;
    padding: ${Spacing.Large};
  `}
`;



// WEBPACK FOOTER //
// ./src/components/atoms/StyledContent/index.js